<mat-toolbar [color]="isAuth ? 'accent' : 'primary'">
  <mat-toolbar-row class="mat-elevation-z2 main-toolbar">
    <button class="nav-toggler" mat-icon-button (click)="onToggleSidenav()" *ngIf="isAuth">
      <mat-icon aria-label="Menu">menu</mat-icon>
    </button>
    <a class="app-name" routerLink="/">
      <img class="hemoLogo" src="../../../assets/icons/logo-hemo-services_white.png">
    </a>

    <ul class="headerNavLinks" *ngIf="isAuth">
      <li class="headerNavLink" *ngFor="let link of headerNavLinks">
        <a mat-list-item class="nav-item" *ngIf="link.route" [routerLink]="link.route" [attr.disabled]="isRouteLoading"
          [ngClass]="{ disabled: isRouteLoading}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <mat-icon aria-label="Nav">{{link.icon}}</mat-icon>
          <span class="link-label">{{link.title | translate}}</span>
        </a>
      </li>

      <li class="headerNavLink">
        <a mat-list-item class="nav-item pointer" (click)="goTocloud()">
          <mat-icon aria-label="Nav">cloud</mat-icon>
          <span class="link-label">Votre espace cloud</span>
        </a>
      </li>
    </ul>


    <ul class="menu-links" *ngIf="isAuth">
      <li class="headerNavLink" *ngIf="isDispatcher">
        <a mat-list-item class="nav-item pointer" (click)="redirectToRuptela()">
          <mat-icon aria-label="Nav">room</mat-icon>
          <span class="link-label">Tracking des véhicules</span>
        </a>
      </li>
      <li>
        <app-notifications></app-notifications>
      </li>
      <li *ngIf="user">
        <app-user-menu [user]="user"></app-user-menu>
      </li>
    </ul>
    <ul class="version" *ngIf="!isAuth">
      <li>
        version {{appVersion}}
      </li>
    </ul>
  </mat-toolbar-row>
</mat-toolbar>